/* eslint-disable no-unused-vars */
import { AreaType } from './components/Map/SetFloorsModal/FloorItem';

// eslint-disable-next-line no-shadow
export enum WidgetType {
  AVERAGE_OCCUPANCY_BAR_GRAPH = 'AverageOccupancyBarGraph',
  AVERAGE_OCCUPANCY_BAR_GRAPH_WITH_DAY_PICKER = 'AverageOccupancyBarGraphWithDayPicker',
  AVERAGE_UTILIZATION_GRAPH = 'AverageUtilizationGraph',
  AVERAGE_OCCUPANCY_LINE_GRAPH = 'AverageOccupancyLineGraph',
  AVERAGE_OCCUPANCY_LINE_GRAPH_WITH_COUNT = 'AverageOccupancyLineGraphWithCount',
  BAR_GRAPH = 'BarGraph',
  BOOKINGS_BY_TIME = 'BookingsByTime',
  BOOKINGS_GRAPH = 'BookingsGraph',
  FOOTFALL_LINE_GRAPH = 'FootfallLineGraph',
  LINE_GRAPH = 'LineGraph',
  METRIC_LINE_GRAPH = 'MetricLineGraph',
  MOST_UTILIZED_SPACES = 'MostUtilizedSpaces',
  NEXT_CLEAN = 'NextClean',
  OCCUPIED_TIME = 'OccupiedTime',
  PEAKS = 'Peaks',
  PIE_CHART = 'PieChart',
  ROOM_BOOKINGS = 'RoomBookings',
  ROOM_UTILIZATION = 'RoomUtilization',
  ROW = 'Row',
  SPACE_UTILIZATION = 'SpaceUtilizationWidget',
  TABLE_OCCUPANCY = 'TableOccupancy',
  TIMES = 'Times',
  TIME_COMPARISON_GRAPH = 'TimeComparisonGraph',
  WEATHER = 'Weather',
}

// eslint-disable-next-line no-shadow
export enum WidgetSize {
  MEDIUM = 'medium',
  LARGE = 'large',
}

export type WidgetItem = {
  name: WidgetType,
  size?: WidgetSize,
  widgets?: WidgetItem[],
  title?: string,
}

const ClientUIConfig = {
  occupancyPage: {
    building: {
      historicView: [
        {
          name: WidgetType.AVERAGE_OCCUPANCY_LINE_GRAPH_WITH_COUNT,
          size: WidgetSize.MEDIUM,
        },
        {
          name: WidgetType.MOST_UTILIZED_SPACES,
          size: WidgetSize.LARGE,
        },
      ],
      liveView: [
        {
          name: WidgetType.SPACE_UTILIZATION,
          size: WidgetSize.MEDIUM,
        },
        {
          name: WidgetType.ROW,
          widgets: [
            {
              name: WidgetType.ROOM_BOOKINGS,
              size: WidgetSize.MEDIUM,
            },
            {
              name: WidgetType.MOST_UTILIZED_SPACES,
              size: WidgetSize.MEDIUM,
            },
          ],
        },
      ],
    },
    floor: {
      historicView: [{
        name: WidgetType.SPACE_UTILIZATION,
        size: WidgetSize.MEDIUM,
      },
      {
        name: WidgetType.MOST_UTILIZED_SPACES,
        size: WidgetSize.MEDIUM,
      }],
      liveView: [{
        name: WidgetType.SPACE_UTILIZATION,
        size: WidgetSize.MEDIUM,
      },
      {
        name: WidgetType.MOST_UTILIZED_SPACES,
        size: WidgetSize.MEDIUM,
      }],
    },
    area: {
      [AreaType.TOILET]: {
        historicView: [{
          name: WidgetType.AVERAGE_OCCUPANCY_BAR_GRAPH_WITH_DAY_PICKER,
          size: WidgetSize.MEDIUM,
        }, {
          name: WidgetType.FOOTFALL_LINE_GRAPH,
          size: WidgetSize.MEDIUM,
        }],
        liveView: [{
          name: WidgetType.NEXT_CLEAN,
          size: WidgetSize.MEDIUM,
        },
        {
          name: WidgetType.SPACE_UTILIZATION,
          size: WidgetSize.MEDIUM,
        },
        {
          name: WidgetType.AVERAGE_OCCUPANCY_BAR_GRAPH,
          size: WidgetSize.MEDIUM,
        }],
      },
      [AreaType.MEETING_ROOM]: {
        historicView: [
          {
            name: WidgetType.AVERAGE_OCCUPANCY_LINE_GRAPH_WITH_COUNT,
            size: WidgetSize.MEDIUM,
          },
          {
            name: WidgetType.AVERAGE_OCCUPANCY_BAR_GRAPH_WITH_DAY_PICKER,
            size: WidgetSize.MEDIUM,
          },
          {
            name: WidgetType.OCCUPIED_TIME,
            size: WidgetSize.MEDIUM,
          },
          {
            name: WidgetType.AVERAGE_UTILIZATION_GRAPH,
            size: WidgetSize.MEDIUM,
          },
          {
            name: WidgetType.BOOKINGS_GRAPH,
            size: WidgetSize.MEDIUM,
          },
          {
            name: WidgetType.TIME_COMPARISON_GRAPH,
            size: WidgetSize.MEDIUM,
          },
        ],
        liveView: [{
          name: WidgetType.SPACE_UTILIZATION,
          size: WidgetSize.MEDIUM,
        },
        {
          name: WidgetType.AVERAGE_OCCUPANCY_BAR_GRAPH,
          size: WidgetSize.MEDIUM,
        },
        {
          name: WidgetType.BOOKINGS_BY_TIME,
          size: WidgetSize.MEDIUM,
        },
        ],
      },
      [AreaType.CONFERENCE_ROOM]: {
        historicView: [
          {
            name: WidgetType.AVERAGE_OCCUPANCY_LINE_GRAPH_WITH_COUNT,
            size: WidgetSize.MEDIUM,
          },
          {
            name: WidgetType.AVERAGE_OCCUPANCY_BAR_GRAPH_WITH_DAY_PICKER,
            size: WidgetSize.MEDIUM,
          },
          {
            name: WidgetType.OCCUPIED_TIME,
            size: WidgetSize.MEDIUM,
          },
          {
            name: WidgetType.AVERAGE_UTILIZATION_GRAPH,
            size: WidgetSize.MEDIUM,
          },
          {
            name: WidgetType.BOOKINGS_GRAPH,
            size: WidgetSize.MEDIUM,
          },
          {
            name: WidgetType.TIME_COMPARISON_GRAPH,
            size: WidgetSize.MEDIUM,
          },
        ],
        liveView: [{
          name: WidgetType.SPACE_UTILIZATION,
          size: WidgetSize.MEDIUM,
        },
        {
          name: WidgetType.AVERAGE_OCCUPANCY_BAR_GRAPH,
          size: WidgetSize.MEDIUM,
        },
        {
          name: WidgetType.BOOKINGS_BY_TIME,
          size: WidgetSize.MEDIUM,
        },
        ],
      },
      [AreaType.CAFE]: {
        historicView: [
          {
            name: WidgetType.AVERAGE_OCCUPANCY_LINE_GRAPH_WITH_COUNT,
            size: WidgetSize.MEDIUM,
          },
          {
            name: WidgetType.AVERAGE_OCCUPANCY_BAR_GRAPH_WITH_DAY_PICKER,
            size: WidgetSize.MEDIUM,
          },
        ],
        liveView: [{
          name: WidgetType.SPACE_UTILIZATION,
          size: WidgetSize.MEDIUM,
        },
        {
          name: WidgetType.TABLE_OCCUPANCY,
          size: WidgetSize.MEDIUM,
        },
        {
          name: WidgetType.AVERAGE_OCCUPANCY_BAR_GRAPH,
          size: WidgetSize.MEDIUM,
        }],
      },
      [AreaType.GYM]: {
        historicView: [
          {
            name: WidgetType.AVERAGE_OCCUPANCY_LINE_GRAPH_WITH_COUNT,
            size: WidgetSize.MEDIUM,
          },
          {
            name: WidgetType.AVERAGE_OCCUPANCY_BAR_GRAPH_WITH_DAY_PICKER,
            size: WidgetSize.MEDIUM,
          },
        ],
        liveView: [{
          name: WidgetType.SPACE_UTILIZATION,
          size: WidgetSize.MEDIUM,
        },
        {
          name: WidgetType.AVERAGE_OCCUPANCY_BAR_GRAPH,
          size: WidgetSize.MEDIUM,
        },
        {
          name: WidgetType.BOOKINGS_BY_TIME,
          size: WidgetSize.MEDIUM,
          title: 'Gym bookings',
        },
        ],
      },
      [AreaType.IT_HELPDESK]: {
        historicView: [
          {
            name: WidgetType.AVERAGE_OCCUPANCY_LINE_GRAPH_WITH_COUNT,
            size: WidgetSize.MEDIUM,
          },
          {
            name: WidgetType.AVERAGE_OCCUPANCY_BAR_GRAPH_WITH_DAY_PICKER,
            size: WidgetSize.MEDIUM,
          },
        ],
        liveView: [{
          name: WidgetType.SPACE_UTILIZATION,
          size: WidgetSize.MEDIUM,
        },
        {
          name: WidgetType.AVERAGE_OCCUPANCY_BAR_GRAPH,
          size: WidgetSize.MEDIUM,
        }],
      },
      [AreaType.RECEPTION]: {
        historicView: [
          {
            name: WidgetType.AVERAGE_OCCUPANCY_LINE_GRAPH_WITH_COUNT,
            size: WidgetSize.MEDIUM,
          },
          {
            name: WidgetType.AVERAGE_OCCUPANCY_BAR_GRAPH_WITH_DAY_PICKER,
            size: WidgetSize.MEDIUM,
          },
        ],
        liveView: [{
          name: WidgetType.SPACE_UTILIZATION,
          size: WidgetSize.MEDIUM,
        },
        {
          name: WidgetType.AVERAGE_OCCUPANCY_BAR_GRAPH,
          size: WidgetSize.MEDIUM,
        }],
      },
    },
    space: {
      historicView: [],
      liveView: [],
    },
  },
  internalEnvironmentPage: {
    building: {},
  },
};

export default ClientUIConfig;
